import React, { useEffect, useState } from "react";
import { Field, FormikProvider, Form, useFormik } from "formik";
import Menubar from "../Menubar";
import { store } from "../../App";
import MasterService from "../../Services/MasterService";
import { AiFillFileExcel, AiOutlineSearch } from "react-icons/ai";
import { Container, Row, Col } from "react-bootstrap";
import { MdOutlinePictureAsPdf } from "react-icons/md";
import autoTable from "jspdf-autotable";
import { commonSelectProps, datetime, exportToExcel, formatNumberIndianWithDecimal, generatelargePdf, generatePdf } from "../utils/commonFunctions";
import AlertModal from "../Alert/AlertModal";import Select from 'react-select';
import useAlert from "../Alert/useAlert";
import KpiService from "../../Services/KpiService";

export default function DistlevelTargetsReport() {
  let username = localStorage.getItem("username"); let roleid = localStorage.getItem("catid"); let district = localStorage.getItem("districtid"); let deptId = localStorage.getItem("deptid");
  const [distlist, setDistrictList] = useState(); const [searchText, setSearch] = useState(""); const [EntryData, setEntrydata] = useState(); const [entrydataEnb, setEntrydataEnb] = useState(false); const [Deptlist, setDeptlist] = useState([]); const [districts, setdistricts] = useState(); const [Distname, setDistname] = useState(); const [Deptname, setDeptname] = useState(); const [currentdate, setcurrentdate] = useState(""); const [currenttime, setcurrenttime] = useState(""); const [uniqueMandals, setuniqueMandals] = useState(); const [selecteddept, setselecteddept] = useState(); const { showAlert, alertData, showAlertMessage, closeAlert } = useAlert();
  const formik = useFormik({
    initialValues: { userId: "", district_id: "", mandal_id: "", department_id: "", periodic_id: "", year: "", date: "", Indicators: [{ indicator_id: "", entry_value: "" }], remarks: "" },
    onSubmit: (values) => { },
  });const [yearList,setYearList] = useState([]);
  useEffect(() => {
    if (["111","113","117","119","112"].includes(roleid) ) {
      formik.setFieldValue("district_id", district);
    }

MasterService.getfinyears().then((achievvalueres) => {
             if (achievvalueres.data) {
               let options = achievvalueres.data.map((item, i) => { return ( <option key={i} value={item.id}> {item.value} </option> ); });
               setYearList(achievvalueres.data);
             }
           });
    MasterService.getDistricts().then((res17) => {
      if (res17.data) {
        setdistricts(res17.data); let options = res17.data.map((item, i) => { return (<option key={item.id} value={item.id}> {item.value} </option>); }); setDistrictList([ { id: "0", value: "All" }, ...( res17.data ?? []) ]);
      }
    });
    let params = { userId: username };
    MasterService.getApplicableDistrictHods(params).then((res) => {
      if (res.data) {
        let options = res.data?.SDESC.map((item, i) => { return (<option key={item.dept_id} value={item.dept_id}> {item.dept_name} </option>); });
        setDeptlist([ { dept_id: "0", dept_name: "All" }, ...(res.data?.SDESC ?? []) ]);
      }
    });

    if (["111", "113", "114"].includes(roleid)) { formik.setFieldValue("department_id", deptId); }

    // if (roleid === "113") {
    //   setDistname(localStorage.getItem("districtname"));

    //   const payload = { userId: username, districtId: district, mandalId: "0", deptId: !["116","119","117"].includes(roleid) ? deptId : formik.values.department_id, buttonType: "District", };

    //   KpiService.getdistWiseTargetReport(payload).then((response) => {
    //     store.dispatch({ type: "HIDE_SPINNER" });
    //     if (response.data.SCODE === "02") {
    //       showAlertMessage(response.data.SDESC, "warning"); setEntrydata([]); setEntrydataEnb(false);
    //     } else {
    //       if (response.data.SCODE === "01") {
    //         setselecteddept(formik.values.department_id); setEntrydataEnb(true); setEntrydata(response.data.SDESC);
    //         if (["111", "113", "114"].includes(roleid)) {
    //           setDeptname(localStorage.getItem("deptcodeName"));
    //         } else {
    //           let dept = response.data.SDESC[0].dept_name;
    //           setDeptname(dept);
    //         }

    //         const uniqueMandals = [...new Set(response.data.SDESC?.map((item) => item.district_name))];
    //         setuniqueMandals(uniqueMandals);
    //       } else {
    //         showAlertMessage(response.data.SDESC, "warning"); setEntrydata([]); setEntrydataEnb(false);
    //       }
    //     }
    //   }).finally(() => { store.dispatch({ type: "HIDE_SPINNER" }); });
    //   formik.setFieldValue("district_id", district);
    // }
  }, []);

  useEffect(() => {
    datetime(setcurrentdate, setcurrenttime);
  }, []);

  const getEntrydata = (yearr) => {

    if (!yearr) {
      return;
    }
    let missingFields = []; if (!formik.values.department_id) missingFields.push("HOD Name"); if (!formik.values.district_id) missingFields.push("District");
    if (missingFields.length > 0) {
      const errorMessage = `Please Select Required Field${missingFields.length > 1 ? "s" : ""}: ${missingFields.join(", ")}.`;
      if (errorMessage) {
        showAlertMessage(errorMessage, "warning");
        setEntrydataEnb(false);
        return;
      }
    }
    const params = { userId: username, districtId: formik.values.district_id, mandalId: "0", deptId: !["111", "113", "114"].includes(roleid) ? formik.values.department_id : deptId, buttonType: "District",year:yearr };
    fetchEntryData(params);
    const filterdistrict = districts?.find((item) => item.id === formik.values.district_id);
    setDistname(filterdistrict?.value);
    if (formik.values.district_id === "0") {
      setDistname("ALL");
    }
  };

  const fetchEntryData = (params) => {
    store.dispatch({ type: "SHOW_SPINNER" });
    KpiService.getdistWiseTargetReport(params).then((res) => {
      store.dispatch({ type: "HIDE_SPINNER" });
      if (res.data.SCODE === "02") {
        showAlertMessage(res.data.SDESC, "warning"); setEntrydata([]); setEntrydataEnb(false);
      } else {
        if (res.data.SCODE === "01") {
          setselecteddept(params.deptId); setEntrydataEnb(true); setEntrydata(res.data.SDESC);
          if (["111", "113", "114"].includes(roleid)) {
            setDeptname(localStorage.getItem("deptcodeName"));
          } else {
            let dept = res.data.SDESC[0].dept_name;
            setDeptname(dept);
          }

          const uniqueMandals = [...new Set(res.data.SDESC?.map((item) => item.district_name))];
          setuniqueMandals(uniqueMandals);

        } else {
          showAlertMessage(res.data.SDESC, "warning");
          setEntrydata([]);
          setEntrydataEnb(false);
        }
      }
    })
      .finally(() => {
        store.dispatch({ type: "HIDE_SPINNER" });
      });
  };
  const Emptyfields = () => { formik.setFieldValue("periodic_id", ""); formik.setFieldValue("year", ""); formik.setFieldValue("category", ""); };
  const filteredData =
    searchText.length > 0 && EntryData?.length
      ? EntryData.filter((item) => {
        return (
          item &&
          Object.keys(item).some((key) => { const value = item[key]; return value !== null && value.toString().toLowerCase().includes(searchText.toLowerCase()); })
        );
      })
      : EntryData;

  const filteredMandals = uniqueMandals?.filter((mandal) => filteredData?.some((item) => item.district_name === mandal));
  const Oncngfun = () => { formik.setFieldValue("periodic_id", ""); formik.setFieldValue("year", ""); formik.setFieldValue("date", ""); formik.setFieldValue("category", ""); };
  return (
    <>
      <Menubar />
      <Container fluid style={{ width: "95%" }}> <div className="sa-title"> <h2> District Targets <span> Report</span> </h2> </div> </Container>

      <Container fluid style={{ width: "95%" }} className="outer-page-content-container mt-3">
        <FormikProvider value={formik}>
          <Form onSubmit={formik.handleSubmit}>
            <div className="mandal-container p-4">
              <Row>
                <Col xs={12} sm={12} md={3} lg={3} xl={3} xxl={3}>
                  <label htmlFor="department_id" className="mb-1 fw-bold"> HOD Name </label>
                  <Select {...commonSelectProps({ name: "department_id", options: Deptlist, value: formik.values.department_id, optionValueKey: "dept_id", optionLabelKey: "dept_name", formik, 
                    isDisabled: ["111", "113", "114"].includes(roleid), extraOnChange: (option) => { 
                      formik.setFieldValue("year", "");setEntrydata([]);
                      // getEntrydata(formik.values.district_id, option ? option.dept_id : "");
                     } })} />
                  
                </Col>

                <Col xs={12} sm={12} lg={3} md={3} xl={3} xxl={3} className="district-select">
                  <label className="mb-1 fw-bold"> District </label> <span style={{ color: "red" }}> *</span>
                  <Select {...commonSelectProps({ name: "district_id", options: distlist, value: formik.values.district_id, optionValueKey: "id", optionLabelKey: "value", formik, isDisabled: roleid === "119" || roleid === "113", 
                    extraOnChange: (option) => { 
                        formik.setFieldValue("year", "");setEntrydata([]);
                      //  Oncngfun();getEntrydata(option? option.id:"",formik.values.department_id);Emptyfields(); 
                       } })} />
                 
                </Col>
                 <Col xs={12} sm={12} lg={3} md={3} xl={3} xxl={3}>
                                                                     <label className="mb-1 fw-bold">Year </label> <span style={{ color: "red" }}> *</span>
                                                                    <Select
                  {...commonSelectProps({ name: "year", options: yearList, value: formik.values.year,
                   optionValueKey: "id", optionLabelKey: "value", formik, isDisabled: false, extraOnChange: (option) => {
                    getEntrydata(option? option.id:"",);
                   } })}
                />   
                                                                   </Col>
              </Row>
            </div>
            <br />
            {entrydataEnb && (
              <>
                <Row className="mb-2">
                  <Col xs={12} sm={12} md={3} lg={3} xl={3} xxl={3} >
                    <div style={{ display: "flex", alignItems: "center", border: "1px solid #ddd", borderRadius: "20px", boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)", transition: "all 0.3s ease-in-out", backgroundColor: "#fff", padding: "5px 10px", width: "150px", minWidth: "150px", }} >
                      <AiOutlineSearch className="me-2" style={{ fontSize: "1.2rem", color: "#888", visibility: "visible" }} />
                      <input type="text" placeholder="Search" value={searchText} onChange={(event) => setSearch(event.target.value)} onFocus={(e) => { e.currentTarget.parentNode.style.boxShadow = "0 6px 12px rgba(0, 0, 0, 0.2)"; e.currentTarget.parentNode.style.border = "1px solid #353935"; e.currentTarget.parentNode.style.width = "100%"; }} onBlur={(e) => { e.currentTarget.parentNode.style.boxShadow = "0 4px 8px rgba(0, 0, 0, 0.1)"; e.currentTarget.parentNode.style.border = "1px solid #ddd"; e.currentTarget.parentNode.style.width = "150px"; }} style={{ flex: "1", border: "none", outline: "none", fontSize: "1rem", color: "#333", backgroundColor: "transparent", transition: "color 0.3s ease", minWidth: "0", }} />
                    </div>
                  </Col>

                  <Col >
                    <button className="btn btn-danger btn-sm  pdf-btn mx-2" onClick={() =>formik.values.district_id!== "0" ? generatePdf("#my-table", "DistrictlevelTargetsReport",selecteddept !== "0" ? filteredMandals.length + 3 : filteredMandals.length + 4): generatelargePdf("#my-table", "DistrictlevelTargetsReport")} style={{ float: "right", marginLeft: "3px" }}> PDF <MdOutlinePictureAsPdf /> </button>
                    <button size="sm" className="btn mx-2 excel-btn" style={{ marginLeft: "3px", float: "right", color: "#ffffff" }} onClick={() => exportToExcel("my-table", "DistrictlevelTargetsReport")}> Excel <AiFillFileExcel style={{ fontSize: "18px" }} /> </button>
                  </Col>
                </Row>

                <div style={{ textAlign: "center", backgroundColor: "#d4e3d8" }} className="rounded-1 border py-1">
                  <span className="style-1">District Level Targets Report Of Of Year {formik.values.year}</span>&nbsp; <br />
                  <span className="style-1"> HOD Name:</span> <span className="style-2">{formik.values.department_id === "0" ? "ALL" : Deptname}</span>
                  <span className="style-1">District:</span> <span className="style-2">{Distname}</span>
                  <div className="text-end style-1">
                    Report On : {currentdate} {currenttime}
                  </div>
                </div>
                <div id="table-scroll" className="table-scroll">
                  <div className="table-wrap">
                    <table className="table table-bordered custom-table table-responsive sticky-table" id="my-table">
                      <thead>
                        <tr className="text-center only-export">
                          <th colSpan={selecteddept !== "0" ? filteredMandals.length + 3 : filteredMandals.length + 4} style={{ backgroundColor: "#d4e3d8", textAlign: "center" }}>
                            <span className="style-1">District Level Targets Report Of Of Year {formik.values.year}</span>
                          </th>
                        </tr>

                        <tr className="text-center only-export">
                          <th colSpan={selecteddept !== "0" ? filteredMandals.length + 3 : filteredMandals.length + 4} style={{ backgroundColor: "#d4e3d8", textAlign: "center" }}>
                            <span className="style-1"> HOD Name:</span> <span className="style-2">{formik.values.department_id === "0" ? "ALL" : Deptname}&nbsp;&nbsp;&nbsp;</span>
                            <span className="style-1">District:</span> <span className="style-2">{Distname}</span>
                          </th>
                        </tr>
                        <tr className="only-export">
                          <th colSpan={filteredMandals.length + 2}>
                            <div className="text-end style-1">
                              Report On : {currentdate} {currenttime}
                            </div>
                          </th>
                        </tr>
                        <tr className="text-center">
                          <th rowSpan={1} className="sticky-col sticky-sno"> Sl.No. </th>
                          {selecteddept === "0" && <th rowSpan={1} className="sticky-col sticky-INDICATOR"> HOD Name </th>}
                          <th rowSpan={1} className={`sticky-col indicator-column ${selecteddept === "0" ? "sticky-UNIT" : "sticky-INDICATOR"}`}> Indicator </th>
                          <th className={`sticky-col indicator-column ${selecteddept === "0" ? "sticky-bunit" : "sticky-UNIT"}`}>Unit</th>
                          {filteredMandals.map((mandal, idx) => (<th key={idx} colSpan={1}> {mandal} </th>))}
                        </tr>
                      </thead>
                      <tbody>
                        {[...new Set(filteredData.map((item) => item.indicator_id))].map((indicatorId, i) => {
                          const indicatorRows = filteredData.filter((item) => item.indicator_id === indicatorId); const indicatorName = indicatorRows[0]?.indicator_name; const unitName = indicatorRows[0]?.unit_name; const unitCatid = indicatorRows[0]?.unit_cat_id;
                          return (
                            <tr key={indicatorId}>
                              <td className="sticky-col sticky-sno" style={{ textAlign: "center" }}> {i + 1} </td>
                              {selecteddept === "0" && <td className="sticky-col indicator-column sticky-INDICATOR" style={{ wordBreak: "break-word", maxWidth: "500px", minWidth: "200px" }}> {indicatorRows[0]?.deptcode}-{indicatorRows[0]?.dept_name} </td>}
                              <td className={`sticky-col indicator-column ${selecteddept === "0" ? "sticky-UNIT" : "sticky-INDICATOR"}`}> {indicatorName} </td>
                              <td style={{ textAlign: "left" }} className={`sticky-col ${selecteddept === "0" ? "sticky-bunit" : "sticky-UNIT"}`} > {unitName} </td>
                              {filteredMandals.map((mandalName, idx) => {
                                const match = indicatorRows.find((item) => item.district_name === mandalName);

                                const value = unitCatid === 1 ? formatNumberIndianWithDecimal(match?.targets_2025) : match?.targets_2025;

                                return (
                                  <td key={idx} style={{ textAlign: "right" }}> {value !== null && value !== undefined ? value : ""} </td>
                                );
                              })}
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>
                </div>
              </>
            )}
          </Form>
        </FormikProvider>
      </Container>
      <AlertModal show={showAlert} titleText={alertData.titleText} alertText={alertData.alertText} onClose={closeAlert} />
    </>
  );
}
